import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("定型メッセージを登録")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 登録する ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_text_area = _resolveComponent("m-text-area")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_base_modal = _resolveComponent("m-base-modal")

  return (_openBlock(), _createBlock(_component_m_base_modal, { onClose: _ctx.close }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_field, {
          label: "メッセージタグ",
          name: "heading",
          type: "text",
          placeholder: "登録したメッセージを探すために使うタグを入力",
          value: _ctx.heading,
          invalid: !_ctx.validHeading,
          "invalid-message": "メッセージタグは入力必須です",
          entered: _ctx.enteredHeading,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.heading = $event)),
          onEnter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.enteredHeading = true))
        }, null, 8, ["value", "invalid", "entered"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_m_text_area, {
          label: "メッセージ本文",
          name: "content",
          placeholder: "実際に送信されるメッセージ本文を入力",
          value: _ctx.content,
          onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.content = $event))
        }, null, 8, ["value"])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.validData && _ctx.allEntered,
        onClick: _ctx.registerMessageTemplate
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}